module.exports = __webpack_public_path__ + "static/media/canada.6d8851ec.jpg";